import { Theme } from '@mui/material'
import { uiColors } from '~/common/styles/colors'
import { typography as textStyles } from '~/common/styles/typography'
import { TextColorVariant, TypographyVariant } from '../types'

const linkStyles = (theme: Theme) => ({
  color: uiColors.content.primary,
  '&:hover': {
    color: theme.palette.common.doss.blue[10],
    cursor: 'pointer',
  },
})

export const getLinkStyles = (typography: TypographyVariant, theme: Theme) => {
  return {
    ...textStyles[typography],
    ...linkStyles(theme),
  }
}

/**
 * Returns the color for the text on the color prop
 */
export const getTextColor = (color: TextColorVariant) => {
  switch (color) {
    case 'primary':
      return uiColors.content.primary
    case 'secondary':
      return uiColors.content.secondary
    case 'danger':
      return uiColors.content.danger
    case 'warning':
      return uiColors.content.warning
    case 'white':
      return uiColors.content.white
    case 'disabled':
      return uiColors.content.disabled
  }
}
